import {ENTITY_ID_KEYS} from 'utils/constants';
import {initialState} from './states';

export const global = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_AUTH': {
            return {
                ...state,
                auth: action.payload,
            };
        }
        case 'SET_WATCHLIST': {
            const {entityType, entityList} = action.payload;
            return {
                ...state,
                watchList: {
                    ...state.watchList,
                    [entityType]: toggleFromWatchList(
                        entityList,
                        {},
                        entityType,
                    ),
                },
            };
        }
        case 'TOGGLE_FROM_WATCHLIST': {
            const {entityType, entityList} = action.payload;
            return {
                ...state,
                watchList: {
                    ...state.watchList,
                    [entityType]: toggleFromWatchList(
                        state.watchList[entityType],
                        entityList,
                        entityType,
                    ),
                },
            };
        }
        case 'SET_USER_PORTFOLIO': {
            return {
                ...state,
                userPortfolio: action.payload,
            };
        }
        case 'SET_EMAIL_FREQ_OPTIONS': {
            return {
                ...state,
                emailFreqOptions: action.payload,
            };
        }
        case 'SET_USER_IMAGE': {
            return {
                ...state,
                userImage: action.payload,
            };
        }
        case 'SET_USER_DETAILS': {
            return {
                ...state,
                watchList:
                    state.user.userId !== action.payload.userId
                        ? initialState.watchList
                        : state.watchList,
                userImage: null,
                userPortfolio:
                    state.user.userId !== action.payload.userId
                        ? initialState.userPortfolio
                        : state.userPortfolio,
                user: action.payload,
                isFreeUser: action.payload.role === 'Free User',
                isSilverUser: action.payload.role === 'Silver User', // Basic
                isGoldUser: action.payload.role === 'Gold User', // Premium
                isPlatinumUser: action.payload.role === 'Platinum User', // Pro
                isAdminUser: action.payload.role === 'Admin', // Admin
                isAnalystUser: action.payload.role === 'Analyst',
                isSalesUser: action.payload.role === 'Sales', //Sales
                isProductionUser: action.payload.role === 'Production',
                isPremiumDigitalUser:
                    action.payload?.role === 'Premium Digital', //Premium Digital
                isPremiumPrimeUser: action.payload?.role === 'Premium Prime', //Premium Prime
                uiPageMenu: action.payload.uiPageMenu,
            };
        }
        case 'SET_HELP_VIDEO': {
            return {
                ...state,
                helpVideoLink: action.payload,
            };
        }
        case 'SET_PWD_CHANGE_POPUP': {
            return {
                ...state,
                showPwdChangePopup: action.payload,
            };
        }
        case 'SET_SHARE_URLS': {
            return {
                ...state,
                shareUrls: action.payload,
            };
        }
        case 'SET_SHARE_URLS_TITLE': {
            return {
                ...state,
                shareUrlsTitle: action.payload,
            };
        }
        case 'SET_ANALYST_DATA': {
            return {
                ...state,
                analystData: action.payload,
            };
        }
        case 'SET_OTHER_ANALYST': {
            return {
                ...state,
                analystData: {
                    ...state.analystData,
                    otherAnalysts: action.payload,
                },
            };
        }
        case 'SET_RECENT_DEVELOPMENTS': {
            return {
                ...state,
                whatsnew: action.payload.whatsnew,
                analystReports: action.payload.analystReports,
            };
        }
        case 'SET_MODAL_VISIBLE':
            return {
                ...state,
                visibleModals: action.payload,
            };
        case 'SET_HELPER_PAGE': {
            return {
                ...state,
                isHelperRequested: action.payload,
            };
        }
        case 'SET_IS_FREE_SHARE_URL_DISABLED': {
            return {
                ...state,
                isFreeShareUrlDisabled: action.payload,
            };
        }
        case 'SET_ACTIVE_MODAL': {
            return {
                ...state,
                activeModal: action.payload,
            };
        }
        case 'LOGOUT': {
            return {...initialState, auth: false};
        }
        default:
            return state;
    }
};

const toggleFromWatchList = (watchlist, companylistHT = {}, entityType) => {
    const key = ENTITY_ID_KEYS[entityType];
    const watchlistHT = Array.isArray(watchlist)
        ? watchlist.reduce((acc, w) => ({...acc, [w[key]]: w}), {})
        : watchlist;

    Object.keys(companylistHT).forEach((cRic) => {
        if (watchlistHT[cRic]) {
            delete watchlistHT[cRic];
        } else {
            watchlistHT[cRic] = companylistHT[cRic];
        }
    });

    return watchlistHT;
};
